<!-- 新闻详情 -->
<template>
  <div class="newsDetails">
    <div class="detailsBg">
      <img :src="bgImg" alt srcset />
      <div class="text width">
        <div class="title">新闻动态</div>
        <div class="introduce">行业新闻动态，了解最新资讯</div>
      </div>
    </div>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="newContent width">
      <div class="contentItem" v-for="(item,i) in details" :key="i">
        <h4>{{item.title}}</h4>
        <div class="timeFrom">
          <span>{{item.create_time | formatDate}}</span>
          <span>来源：{{item.source}}</span>
        </div>
        <p class="con">
          <mavon-editor
            class="md"
            :value="item.content"
            :subfield="false"
            :defaultOpen="'preview'"
            :toolbarsFlag="false"
            :editable="false"
            :scrollStyle="true"
            :ishljs="true"
            style="box-shadow: none"
          />
        </p>
        <div class="stopCon">————————转自{{item.source}}</div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { Footer },
  props: {},
  data() {
    return {
      bgImg: require('../assets/images/u0.jpg'),
      details: [],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getGoodsDetail()
  },
  methods: {
    async getGoodsDetail() {
      let routerParams = this.$route.query.goodsDetail
      const res = await this.$http.post('/getNewsInfo', { ids: routerParams })
      this.details = res.data.data
    },
  },
}
</script>

<style lang="less" scoped>
.detailsBg {
  position: relative;
  height: 450px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
  .text {
    position: absolute;
    top: 120px;
    left: 50%;
    width: 900px;
    margin-left: -450px;
    .title {
      font-weight: 700;
      font-size: 32px;
      color: #fff;
    }
    .introduce {
      font-size: 18px;
      color: #fff;
      margin-top: 30px;
    }
  }
}
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.newContent {
  margin-bottom: 10px !important;
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom: 20px;
  .contentItem {
    width: 880px;
    margin: 0 auto;
    h4 {
      font-weight: 700;
      font-size: 18px;
      text-align: center;
      padding-top: 20px;
      margin: 0;
    }
    .timeFrom {
      text-align: center;
      margin-top: 20px;
      span {
        margin: 0 40px;
      }
    }
    .con {
      font-size: 15px;
      line-height: 24px;
      text-indent: 2em;
    }
    .stopCon {
      text-align: right;
    }
  }
}
</style>